import { createSearchFriendlyString } from '@utils/common';

function filterOptionsByQuery(values, query) {
  if (!query) {
    return values;
  }
  const needle = createSearchFriendlyString(query);
  return values.filter(value => {
    const haystack = createSearchFriendlyString(typeof value === "string" ? value : typeof value.label === "string" ? value.label : value.id);
    return haystack.includes(needle);
  });
}

export { filterOptionsByQuery };
//# sourceMappingURL=util.filter-by-query.js.map
